(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fast-filters"] && !Shopify.designMode) return;
  try {
    class FastFiltersCarousel extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      if (!this.slideshow) return;

      this.scroller =
        this.slideshow.refs?.scroller ||
        this.slideshow.querySelector('slideshow-slides');

      this.updateArrowVisibility = this.updateArrowVisibility.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onSelect = this.onSelect.bind(this);

      // select fires before scroll animation finishes — re-check on scroll/scrollend
      this.slideshow.addEventListener('slideshow:select', this.onSelect);
      this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
      this.scroller?.addEventListener('scrollend', this.updateArrowVisibility);

      requestAnimationFrame(() => {
        this.updateArrowVisibility();
      });

      this.resizeObserver = new ResizeObserver(() => {
        this.updateArrowVisibility();
      });
      this.resizeObserver.observe(this.slideshow);
    }

    disconnectedCallback() {
      if (this.slideshow) {
        this.slideshow.removeEventListener('slideshow:select', this.onSelect);
      }
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.onScroll);
        this.scroller.removeEventListener('scrollend', this.updateArrowVisibility);
      }
      clearTimeout(this.settleTimer);
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    onScroll() {
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.updateArrowVisibility();
      });
    }

    onSelect() {
      // Fallback when scrollend unsupported / missed
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(this.updateArrowVisibility, 350);
    }

    updateArrowVisibility() {
      if (!this.slideshow || !this.scroller) return;

      // Scroll-based: no overflow → both ends true → both arrows hide
      const atStart = this.scroller.scrollLeft <= 1;
      const atEnd =
        this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 1;

      this.slideshow.toggleAttribute('at-start', atStart);
      this.slideshow.toggleAttribute('at-end', atEnd);

      const prevButton = this.slideshow.querySelector('.slideshow-control--previous');
      const nextButton = this.slideshow.querySelector('.slideshow-control--next');

      if (prevButton) prevButton.disabled = atStart;
      if (nextButton) nextButton.disabled = atEnd;
    }
  }

  if (!customElements.get('fast-filters-carousel')) {
    customElements.define('fast-filters-carousel', FastFiltersCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
